import { render, staticRenderFns } from "./medalEventManagement.vue?vue&type=template&id=4e15e02d&scoped=true&"
import script from "./medalEventManagement.vue?vue&type=script&lang=js&"
export * from "./medalEventManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e15e02d",
  null
  
)

component.options.__file = "medalEventManagement.vue"
export default component.exports